<template>
<div>
      <div class="vx-row">
        <!-- MULTIPLE COLUMNS-->
        <div class="vx-col w-3/4 mb-base">
     



          <vx-card title="" style="margin-top:10px;">
          <vs-table :data="sipariseGoreUrunListesi">
        <template slot="thead">
        
          <vs-th  sort-key="stokkodu">Stok Kodu</vs-th>
        
          <vs-th>Stok Adı</vs-th>
          <vs-th>Sipariş Adeti</vs-th>
          <vs-th>Tutar</vs-th>
          <vs-th>Sil</vs-th>
        
        </template>

          <template slot-scope="{data}">
            <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
              
              <vs-td :data="data[indextr].stokKodu">
                {{ data[indextr].stokKodu }}
              </vs-td>
              <vs-td :data="data[indextr].stokAdi">
                {{ data[indextr].stokAdi }}
              </vs-td>
              <vs-td :data="data[indextr].adet">
                  <vs-input class="inputx" :id="'cv' + data[indextr].id" @keyup.enter="adetGuncelle(data[indextr].id)" v-bind:value="data[indextr].adet" />

              </vs-td>
              <vs-td>{{yuvarla((data[indextr].fiyat)*data[indextr].adet)}}
                
              </vs-td>
              <vs-td>
                  <vs-button color="warning" @click="sil(data[indextr].id)" class="w-full">Sil</vs-button>
              </vs-td>
            </vs-tr>

            <vs-tr>
              <vs-td>
                
              </vs-td>
              <vs-td >
               
              </vs-td>
              <vs-td >
               
              </vs-td>
              <vs-td >
               
              </vs-td>
             <vs-td >
               
              </vs-td>
            </vs-tr>
          </template>

      </vs-table>
      </vx-card>

        </div>

        <div class="vx-col w-1/4 mb-base">
      <vx-card>
                            <p class="text-grey mb-3">Sipariş Detayları</p>
                             <div class="flex justify-between">
                                <span class="font-semibold">Paket</span>
                                <span class="font-medium text-danger cursor-pointer">
                                   <v-select :value="selected" v-model="selected" @input="ps"  :options="options" style="width:220px"></v-select>
                                </span>
                            </div>

                            <div class="flex justify-between">
                                <span class="font-semibold">Ad Soyad</span>
                                <span class="font-medium text-danger cursor-pointer">
                                  <vs-input class="inputx" v-model="adSoyad" />
                                </span>
                            </div>
                            
                             <div class="flex justify-between">
                                <span class="font-semibold">E-Mail</span>
                                <span class="font-medium text-danger cursor-pointer">
                                  <vs-input class="inputx" v-model="email" />
                                </span>
                            </div>
                             <div class="flex justify-between">
                                <span class="font-semibold">Telefon</span>
                                <span class="font-medium text-danger cursor-pointer">
                                  <vs-input class="inputx" v-model="telefon" />
                                </span>
                            </div>
                            <div class="flex justify-between">
                                <span class="font-semibold">TC&Vergi No</span>
                                <span class="font-medium text-danger cursor-pointer">
                                  <vs-input class="inputx" v-model="tc" />
                                </span>
                            </div>
                            <div class="flex justify-between">
                                <span class="font-semibold">Vergi Dairesi</span>
                                <span class="font-medium text-danger cursor-pointer">
                                  <vs-input class="inputx" v-model="vergiDairesi" />
                                </span>
                            </div>
                            <div class="flex justify-between">
                                <span class="font-semibold">İskonto</span>
                                <span class="font-medium text-danger cursor-pointer">
                                  <vs-input class="inputx" v-model="iskonto" @keyup="iskontoHesapla()" />
                                </span>
                            </div>

                          
                             <div class="flex justify-between mb-2">
                                <span class="text-grey">Ara Toplam ₺</span>
                                <span> {{genelToplam}}</span>
                            </div>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">Genel Toplam ₺</span>
                                <span> {{genelToplam1}}</span>
                            </div>
                            
                            <vs-divider />
                            <div class="flex justify-between mb-2">
                            <vs-button id="button-with-loading"  class="w-full vs-con-loading__container" @click="faturaOlustur()" style="height:70px">{{butonAdi}}</vs-button>
                            </div>

                             <div class="flex justify-between mb-2">
                            <vs-button id="button-with-loading"  class="w-full vs-con-loading__container" color="red" @click="faturaOlustur1()" style="height:70px">Fatura Kes</vs-button>
                            </div>

                           

                           


                           
                        </vx-card>

                       
                            
                       
    </div>
      </div>
    
<div class="vx-row">
    <!-- MULTIPLE COLUMNS-->

    <div class="vx-col w-3/4 mb-base">
      
    </div>



    


        <div class="vx-col w-1/4 mb-base">
          <vx-card title="">
            
          </vx-card>
        </div>
  </div>

     
     
<iframe width="1" height="1" id="ciktiPdf" src="" frameborder="0"></iframe>
       
</div>

</template>

   


<script>
import vSelect from 'vue-select'
import state from '../../store/state'
import Store from '../../store/store'

export default {
  components: {
    'v-select': vSelect,
  },
  data () {
    return {
      selected:{id: 0, label: 'Müşteri'},
        butonAdi:'',
        options: [],
        optionsParti: [],
        optionsPaket:[],
        pazaryeriTum:[],
        list: [],
        listSonFaturalar: [],
        listSiparis:[],
        sipariseGoreUrunListesi:[],
        progress:0,
        activePrompt:false,
        pazaryeriVal:'',
        partiVal:'',
        toplamParca:0,
        selectedParti:{id: 0, label: 'Parti Nolar'},
        popupActive: false,
        popupFatura: false,
        popupActiveSiparis: false,
        popupActiveCikti:false,
        barkod:'',
        siparisBulOrderNumber:'',
        genelSiparisNo:'',
        genelKargoAdi:'',
        genelKargoNo:'',
        genelPartiNo:'',
        genelMusteri:'',
        hediyeMi:0,
        siparisNotu:'',
        il:'',
        ilce:'',
        genelToplam:0,
        eklenenDeger:'',
        indext:0,
        indext1:0,
        urunResim:"",
        validated:1,
        validatedF:1,
        siparisToplamParca:0,
        eklenenToplamParca:0,
        askiDurumu:false,
        aski:0,
        imageLink:"",
        ciktiListesi:[],
        jsonD:'',
        dr:'',
        popupActiveFaturaCikti:false,
        receiptId:0,
        faturaNo:'',
        ilkOkuma:0,
        recId:0,
        total:0,
        faturaAranan:'',
        faturaBulOrderNumber:'',
        im:0,
        paketAdet:'Koli Adeti Seçiniz',
        siparisSayisi:'',
        pls:'',
        siparisDurum:0,
        adSoyad:'',
        email:'',
        telefon:'',
        tc:'',
        vergiDairesi:'',
        islemDurumu:0,
        iskonto:0,
        genelToplam1:'0',
          }
  },
  methods: {

    iskontoHesapla() {
      let hesapla=parseFloat(this.genelToplam)-(parseFloat(this.genelToplam)*parseFloat(this.iskonto)/100);
      console.log(hesapla);
      this.genelToplam1=hesapla;
    },
    ps() {
       
      //this.dataStokListesi=null
      var vm = this
      const soap = require('soap')
      const url = state.sistemAddress

      const args = {program:'Mikro', baslik:'satisBekleyenMusteriUrunleri',ARANAN:this.selected.label,  token:Store.state.tokenId, companyID:Store.state.plasiyer}
      console.log(args)
      soap.createClient(url, function(err, client){
      client.standartSorgular(args, function(err, result){
      

       vm.veriler=JSON.parse(result.standartSorgularResult)
     //  console.log(vm.veriler)
      vm.veriler.forEach(element => {
        vm.sipariseGoreUrunListesi.push(element)
        vm.adSoyad=element.adSoyad
        vm.telefon=element.telefon
        vm.email=element.email
      });
      vm.islemDurumu=2
        vm.butonAdi='Fatura Kes';
      //console.log(vm.sipariseGoreUrunListesi)
      vm.islemYap();
      // vm.popupSiparisListesi=true;
      })
     
      })

    },
    yuvarla(x) {
  return Number.parseFloat(x).toFixed(2);
},
islemYap() {
 
  let t=0;
  this.sipariseGoreUrunListesi.forEach(element => {
      t=t+parseFloat((element.fiyat)*element.adet);
      
  })
  this.genelToplam=this.yuvarla(t);
  //this.genelToplam=parseFloat(this.genelToplam)+parseFloat(tutar)
},
   adetGuncelle(id) {
      var vm = this
      
     const soap = require('soap')
      const url = state.sistemAddress
     // alert(this.pazaryeriVal)
      const args = {id:id,adet:document.getElementById('cv'+id).value}
      soap.createClient(url, function(err, client){
      client.sepetUpdate(args, function(err, result){
        if (result.sepetSilResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        } else {
         vm.siparisSec();
     
        }
      
      
      })
      })

    // alert(document.getElementById('cv'+stokKodu).value);
   },
   faturaOlustur1() {
     this.islemDurumu=2;
     this.faturaOlustur();
   },
   faturaOlustur() {
     
    
     if (this.adSoyad=='' & this.email=='' & this.telefon=='') {
         alert("Ad Soyad , E-Mail, Telefon Alanları Zorunludur");
         
     } else {
     //alert(this.islemDurumu)
     if (this.islemDurumu=='1') {
      var vm = this
      
     const soap = require('soap')
      const url = state.sistemAddress
     // alert(this.pazaryeriVal)
      const args = {adSoyad:this.adSoyad,email:this.email,telefon:this.telefon,kullanici:Store.state.plasiyer,iskonto:this.iskonto}
     // console.log(args)
      soap.createClient(url, function(err, client){
      client.sepetKayit(args, function(err, result){
        if (result.sepetKayitResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        } else {
        //  console.log(result.sepetKayitResult)
        vm.adSoyad='';
        vm.email='';
        vm.telefon='';
        vm.iskonto=0;
         vm.siparisSec();
         vm.paketListesi();
        }
      
      
      })
      })
     } else {
        var vm = this
      
     const soap = require('soap')
      const url = state.sistemAddress
     // alert(this.pazaryeriVal)
      const args = {adSoyad:this.adSoyad,tc:this.tc,vergiDairesi:this.vergiDairesi,email:this.email,telefon:this.telefon}
     // console.log(args)
      soap.createClient(url, function(err, client){
      client.magazaFatura(args, function(err, result){
        if (result.magazaFaturaResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        } else {
         // console.log(result.magazaFaturaResult)
         let p=result.magazaFaturaResult.split('*');
          document.getElementById("ciktiPdf").src=Store.state.printAddress2+p[1]+"&Tr=Magaza&sayi=1-1";
        // vm.siparisSec();
     
        }
      
      
      })
      })
     }
     }
   },
    sil(id) {
        var vm = this
      
     const soap = require('soap')
      const url = state.sistemAddress
     // alert(this.pazaryeriVal)
      const args = {id:id}
      soap.createClient(url, function(err, client){
      client.sepetSil(args, function(err, result){
        if (result.sepetSilResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        } else {
         vm.siparisSec();
     
        }
      
      
      })
      })
    },
    indexbul(array, conditionFn) {
        const item = array.find(conditionFn)
        return array.indexOf(item)
      },
    ps1(text) {
      this.partiVal=text
    },


    siparisSec() {

     var vm = this
      
     const soap = require('soap')
      const url = state.sistemAddress
     // alert(this.pazaryeriVal)
      const args =  {kullanici:Store.state.plasiyer}
      soap.createClient(url, function(err, client){
      client.sepetListesi(args, function(err, result){
        if (result.sepetListesiResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        } else {
          vm.veriler=JSON.parse(result.sepetListesiResult)
      vm.sipariseGoreUrunListesi=vm.veriler

      if (vm.veriler.length>0) {
      if (vm.veriler[0].islem=='0') {
        vm.islemDurumu=1
        vm.butonAdi='Depoya Gönder';
      }
      if (vm.veriler[0].islem=='1') {
        vm.islemDurumu=2
        vm.butonAdi='Fatura Kes';
      }
      }
     vm.islemYap();
        }
      
      
      })
      })

        

     
     
   },
   paketListesi() {

     this.options=[]
      //this.dataStokListesi=null
      var vm = this
      const soap = require('soap')
      const url = state.sistemAddress

      const args = {program:'Mikro', baslik:'satisBekleyenMusteriler',ARANAN:'',  token:Store.state.tokenId, companyID:''}
      soap.createClient(url, function(err, client){
      client.standartSorgular(args, function(err, result){
      

       vm.veriler=JSON.parse(result.standartSorgularResult)
      // console.log(vm.veriler)
       vm.options=vm.veriler 
      // vm.popupSiparisListesi=true;
      })
     
      })

        

     
     
   },
   

          },
  beforeMount(){
   // console.log(Store.state.plasiyer)
  //setInterval(this.stokGuncelle,900000);
     
    this.siparisSec();
    this.paketListesi();
              }
  
}

</script>
<style lang="scss" scoped>
.mb-base { margin-bottom: 0.75rem!important;}
.list-view-item {
    .item-name, .item-description {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .item-name {
        -webkit-line-clamp: 2;
    }

    .item-description {
        -webkit-line-clamp: 5;
    }

    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
</style>